import React from "react";
import { toggle } from "../../../../util/common";
import { BusinessCreditReportStatePII, ICorporateOfficer } from "../../../../store/businessCreditReportService/types";

interface IProps {
    reportObject: BusinessCreditReportStatePII;
    showAsAccordion?: boolean;
    creditProvider?: any;
}
const CompanyInformationCorporateOfficer: React.FunctionComponent<IProps> = (props) => {
    return (
        <React.Fragment>
            <div role="listitem" className="data-row">
                <div className="link-item">
                    {props.showAsAccordion ? (
                        <button
                            type="button"
                            aria-expanded="false"
                            className="link-button"
                            id="btn-corporate-officer"
                            onClick={(e) => toggle("corporate-officer-details", "btn-corporate-officer")}
                        >
                            <span className="row link-item">
                                <span className="col-xs col-no-gutter link-text">
                                    <span className="link-title">
                                        <span className="sr-only btn-toggle-status">Show</span> Corporate Officer
                                    </span>
                                </span>
                            </span>
                        </button>
                    ) : (
                        <h5 className="report-sub-title">Corporate Officer</h5>
                    )}

                    <div
                        className="wallet-details"
                        id="corporate-officer-details"
                        style={{ ...(props.showAsAccordion ? { display: "none" } : {}) }}
                        aria-hidden="true"
                    >
                        {props.reportObject?.businessCompanyReport?.corporate_officers?.map((officer: ICorporateOfficer, index: number) => (
                            <React.Fragment key={`officer-${index}`}>
                                <div role="grid" className="data-grid row-height-xs " aria-labelledby={`officer-details-${index}`}>
                                    <div role="row" className="data-row condensed row">
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-label" id={`contact-${index}-name`}>
                                                Contact Name
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-8 col-sm-8 col-no-gutter">
                                            <div className="data-value" aria-labelledby={`contact-${index}-name`}>
                                                {officer.contact_name}
                                            </div>
                                        </div>
                                    </div>

                                    <div role="row" className="data-row condensed row">
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-label" id={`contact-${index}-title`}>
                                                Contact Title
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-8 col-sm-8 col-no-gutter">
                                            <div className="data-value" aria-labelledby={`contact-${index}-title`}>
                                                {officer.contact_title}
                                            </div>
                                        </div>
                                    </div>

                                    <div role="row" className="data-row condensed row">
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-label" id={`contact-${index}-address`}>
                                                Address
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-8 col-sm-8 col-no-gutter">
                                            <div className="data-value" aria-labelledby={`contact-${index}-address`}>
                                                {officer.address}
                                            </div>
                                        </div>
                                    </div>

                                    <div role="row" className="data-row condensed row">
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-label" id={`contact-${index}-city`}>
                                                City
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-8 col-sm-8 col-no-gutter">
                                            <div className="data-value" aria-labelledby={`contact-${index}-city`}>
                                                {officer.city}
                                            </div>
                                        </div>
                                    </div>

                                    {props.creditProvider === "DUNBRADSTREET" && (
                                        <div role="row" className="data-row condensed row">
                                            <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                                <div className="data-label" id={`contact-${index}-state`}>
                                                    State
                                                </div>
                                            </div>
                                            <div role="gridcell" className="col-xs-8 col-sm-8 col-no-gutter">
                                                <div className="data-value" aria-labelledby={`contact-${index}-state`}>
                                                    {officer.state}
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    <div role="row" className="data-row condensed row">
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-label" id={`contact-${index}-zipcode`}>
                                                Zip Code
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-8 col-sm-8 col-no-gutter">
                                            <div className="data-value" aria-labelledby={`contact-${index}-zipcode`}>
                                                {officer.zip_code}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {props.reportObject?.businessCompanyReport?.corporate_officers?.length !== index + 1 && (
                                    <div className="line-divider margin-vertical-xs"></div>
                                )}
                            </React.Fragment>
                        ))}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default CompanyInformationCorporateOfficer;
